






































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator } from 'vee-validate';

import { EPaymentMethod, ECardStep } from '@/helpers/enums';
import { Payment } from '@/classes/Checkout/Payment';
import CustomPaymentParameters from '@/classes/CustomPaymentParameters';

import { ICustomPaymentParameters } from '@/interfaces/CustomPaymentParameters';
import { ICheckoutCartOffer } from '@/interfaces/Checkout';

import Disclaimer from '@/shared/components/Disclaimer/Disclaimer.vue';
import LabelCreditCardDiscount from '@/shared/components/Labels/LabelCreditCardDiscount.vue';
import FirstCreditCardForm from '../../Form/CreditCards/FirstCreditCardForm.vue';
import SecondCreditCardForm from '../../Form/CreditCards/SecondCreditCardForm.vue';

const CheckoutModule = namespace('App/Checkout');
const AppModule = namespace('App');

@Component({
  components: {
    Disclaimer,
    FirstCreditCardForm,
    SecondCreditCardForm,
    LabelCreditCardDiscount,
  }
})
export default class CreditCards extends Vue {
  @Prop()
  private paymentConditions: any;

  public $refs!: {
    firstCardForm: FirstCreditCardForm,
    secondCardForm: SecondCreditCardForm,
  };

  private validator = new Validator();

  private form = {
    firstCard: {
      newCard: {
        card_flag: null,
        card_number: null,
        owner_name: null,
        cvv: null,
        expiration_date: null,
      },
      creditCardId: null,
      amount: null,
      installments: 1,
    },
    secondCard: {
      newCreditCard: {
        card_flag: null,
        card_number: null,
        owner_name: null,
        cvv: null,
        expiration_date: null,
      },
      creditCardId: null,
      amount: null,
      installments: 1,
    }
  };

  private secondCardIsSelected: boolean = false;

  private showNewCardForm: boolean = false;

  private customPaymentParameters: ICustomPaymentParameters = new CustomPaymentParameters();

  @AppModule.Mutation
  private setCustomPaymentParameters!: Function;

  @CheckoutModule.Mutation
  private setPaymentConditionId!: Function;

  @CheckoutModule.Mutation
  private setMainPaymentCondition!: Function;

  @CheckoutModule.Mutation('setSecondPaymentCondition')
  private sendSecondPaymentCondition!: Function;

  @CheckoutModule.Mutation
  private selectOfferPaymentSecondCard: Function;

  @CheckoutModule.Getter('selectedOfferPaymentCardSelected')
  private selectedPaymentCard: any;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  @CheckoutModule.Getter('selectedOffer')
  private offer: ICheckoutCartOffer;

  private get creditCardsTreated(): any {
    return this.payment.cards.options;
  }

  private get hasCreditCard() {
    return this.creditCardsTreated && this.creditCardsTreated.length > 0;
  }

  private get hasSecondCreditCard() {
    return this.secondCreditCardsTreated && this.secondCreditCardsTreated.length > 0;
  }

  private get secondCreditCardsTreated(): any {
    if (this.hasCreditCard) {
      this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'secondStep', ECardStep.select);

      if (this.showButtonToCreditCard) {
        return this.form && this.form.firstCard.creditCardId && this.creditCardsTreated;
      }

      return this.form && this.form.firstCard.creditCardId && this.creditCardsTreated.filter((value: any) => value.id !== this.form.firstCard.creditCardId);
    }

    this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'secondStep', ECardStep.new);

    return [];
  }

  private get stepCreditCardSelected() {
    return this.payment && this.payment.getPaymentMethod(EPaymentMethod.creditCard) && this.payment.getPaymentMethod(EPaymentMethod.creditCard).step;
  }

  private get paymentConditionMainCreditCard() {
    return this.getPaymentConditionByMethod(EPaymentMethod.creditCard, true);
  }

  private get paymentConditionSecondCreditCard() {
    return this.getPaymentConditionByMethod(EPaymentMethod.creditCard);
  }

  private get mainCreditCardInstallments() {
    return this.paymentConditionMainCreditCard && this.buildCreditCardInstallments(this.paymentConditionMainCreditCard);
  }

  private get secondCreditCardInstallments() {
    return this.paymentConditionSecondCreditCard && this.buildCreditCardInstallments(this.paymentConditionSecondCreditCard);
  }

  private get mainAmount() {
    return this.paymentConditionMainCreditCard && this.paymentConditionMainCreditCard.amount;
  }

  private get secondAmount() {
    return this.paymentConditionSecondCreditCard && this.paymentConditionSecondCreditCard.amount;
  }

  private get stepSecondCreditCardSelected() {
    return this.payment && this.payment.getPaymentMethod(EPaymentMethod.creditCard) && this.payment.getPaymentMethod(EPaymentMethod.creditCard).secondStep;
  }

  private get showButtonToCreditCard() {
    return this.hasCreditCard && this.stepCreditCardSelected === ECardStep.new;
  }

  private get showButtonToSecondCreditCard() {
    return !this.hasSecondCreditCard || this.stepSecondCreditCardSelected === ECardStep.new;
  }

  private get showEmpiricusCardMessage() {
    return process.env.VUE_APP_EMPIRICUS_CARD_MESSAGE_TOGGLE_FEATURE === 'true';
  }

  private buildCreditCardInstallments(paymentCondition: any) {
    const installments = paymentCondition && paymentCondition.installments;

    return (
      installments &&
      installments.map((installment: any) => {
        return {
          ...installment,
          text: this.buildCreditCardInstallment(
            installment.number,
            installment.amount,
            paymentCondition,
          )
        };
      })
    );
  }

  private buildCreditCardInstallment(number: number, amount: number, paymentCondition: any) {
    return `
      ${number}x ${this.$t('App.of')}
      ${this.$n(amount, 'currency')}
      ${number === 1 && amount > 0 && paymentCondition.discount_percentage
    ? `(${paymentCondition.discount_percentage}% de desconto)`
    : ''}
    `;
  }

  private getPaymentConditionByMethod(method: EPaymentMethod, isMainPaymentCondition?: boolean) {
    if (isMainPaymentCondition) {
      return this.paymentConditions && this.paymentConditions.payment_conditions.find((paymentCondition: any) => {
        return paymentCondition.payment_method_code === method && paymentCondition.main_payment_condition;
      });
    }

    return this.paymentConditions && this.paymentConditions.payment_conditions.find((paymentCondition: any) =>  {
      return paymentCondition.payment_method_code === method && !paymentCondition.main_payment_condition;
    });
  }

  private showCreditCardsOptions(isFirstForm: boolean) {
    if (isFirstForm) {
      this.showNewCardForm = false;
      this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'step', ECardStep.select);
    } else {
      this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'secondStep', ECardStep.select);
    }

  }

  private resetSecondForm() {
    this.form.secondCard = {
      newCreditCard: this.form.secondCard.newCreditCard,
      creditCardId: null,
      installments: 1,
      amount: this.secondAmount,
    };
  }

  private selectPaymentCard(payload: any) {
    this.$emit('setCreditCard', payload);
  }

  private selectPaymentSecondCard (cardId: number | null) {
    this.selectOfferPaymentSecondCard({
      offer_id: this.offer.id,
      card_id: cardId,
    });
  }

  private setCardStep(cardStep: any) {
    this.$emit('setCardStep', cardStep);
  }

  private setPaymentCardInstallment(payload: any) {
    this.$emit('setCardInstallment', payload);
  }

  private setEligibilityByAmount() {
    this.customPaymentParameters = {
      offer_payment_condition_id: this.paymentConditions && this.paymentConditions.offer_payment_condition_id,
      input_payment_condition_id: this.paymentConditionMainCreditCard && this.paymentConditionMainCreditCard.id,
      input_amount: this.form && this.form.firstCard.amount,
      main_payment_condition: {
        payment_method_code: EPaymentMethod.creditCard,
      },
      second_payment_condition: {
        payment_method_code: EPaymentMethod.creditCard
      }
    };
    this.setCustomPaymentParameters(this.customPaymentParameters);
    this.$emit('getEligibilityByAmount', this.customPaymentParameters);
  }

  private setSecondPaymentCondition() {
    const second_payment_condition = {
      id: this.paymentConditionSecondCreditCard && this.paymentConditionSecondCreditCard.id,
      amount: this.form && this.form.secondCard.amount,
      installments: this.form && this.form.secondCard.installments,
      payment_method_code: this.paymentConditionSecondCreditCard && this.paymentConditionSecondCreditCard.payment_method_code,
      payment_profile: this.form.secondCard,
    };

    this.sendSecondPaymentCondition(second_payment_condition);
  }

  private async validateForm() {
    const isValidFirstForm = await this.validateFirstForm();
    const isValidSecondForm = await this.validateSecondForm();

    return isValidFirstForm && isValidSecondForm;
  }

  private validateFirstForm() {
    return new Promise(async (resolve, reject) => {
      let error = { erroredElementHeight: null as any };

      const result = this.stepCreditCardSelected === ECardStep.select
        ? await this.validator.validateAll({
          ...this.form.firstCard,
        }) : await this.$refs.firstCardForm.validateForm();

      const firstCardForm = this.$refs.firstCardForm;

      let element = null;
      this.$nextTick(() => {
        const firstField = Object.keys(this.validator.errors.collect())[0];

        if (firstField) {
          if (firstCardForm.$refs.hasOwnProperty(firstField)) {
            element = firstCardForm.$refs[firstField] as any;
            error.erroredElementHeight =
              element.$el.offsetParent.offsetTop - element.$el.offsetHeight;
            element.focus();
          }
        }
      });

      result ? resolve() : reject(error);
    });
  }

  private validateSecondForm() {
    return new Promise(async (resolve, reject) => {
      let error = { erroredElementHeight: null as any };

      const result = await this.$refs.secondCardForm.validateForm();

      const secondCardForm = this.$refs.secondCardForm;

      let element = null;
      this.$nextTick(() => {
        const firstField = Object.keys(this.validator.errors.collect())[0];

        if (firstField) {
          if (secondCardForm.$refs.hasOwnProperty(firstField)) {
            element = secondCardForm.$refs[firstField] as any;
            error.erroredElementHeight =
              element.$el.offsetParent.offsetTop - element.$el.offsetHeight;
            element.focus();
          }
        }
      });

      result ? resolve() : reject(error);
    });
  }

  private setSecondStep() {
    if (this.secondCreditCardsTreated && this.secondCreditCardsTreated.length > 0 && !this.showButtonToSecondCreditCard) {
      this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'secondStep', ECardStep.select);
    } else {
      this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'secondStep', ECardStep.new);
    }
  }

  @Watch('form.firstCard.newCreditCard')
  private onChangeFirstNewCreditCard(val: any) {
    this.payment.setCard(val);
  }

  @Watch('form.firstCard.creditCardId', { immediate: true, deep: true })
  private onChangeCreditCardId(val: any) {
    this.resetSecondForm();
  }

  @Watch('form', { immediate: true, deep: true })
  private onChangeForm() {
    this.setMainPaymentCondition({
      id: this.paymentConditionMainCreditCard && this.paymentConditionMainCreditCard.id,
      installments: this.form.firstCard.installments,
      amount: this.form.firstCard.amount,
    });

    this.form.secondCard.amount = this.secondAmount;

    this.setSecondPaymentCondition();
    this.showButtonToSecondCreditCard && this.setSecondStep();

    if (this.form && this.form.secondCard && this.form.secondCard.creditCardId) {
      this.selectPaymentSecondCard(this.form.secondCard.creditCardId);
    }
  }

  @Watch('form.secondCard.newCreditCard', { deep: true })
  private async onChangeSecondCardForm(val: any) {
    if (val && val.card_number !== null && val.card_number !== ''
    && val.card_flag !== null && val.card_flag !== ''
    && val.owner_name !== null && val.owner_name !== ''
    && val.cvv !== null && val.cvv !== ''
    && val.expiration_date !== null && val.expiration_date !== '' && val.token === null) {
      await this.$refs.secondCardForm.$refs.newCreditCardForm.validateForm();
      this.setSecondPaymentCondition();
    }
  }

  @Watch('paymentConditions', { immediate: true, deep: true })
  private onChangePaymentConditions() {
    this.form.secondCard.amount = this.secondAmount;
  }

  async mounted() {
    this.setSecondStep();
    this.paymentConditions && await this.setPaymentConditionId(this.paymentConditions.offer_payment_condition_id);
  }
}
